// extracted by mini-css-extract-plugin
export default {"content":"LoginWeb_content__7EOW-","content__actions":"LoginWeb_content__actions__N-NWN","input":"LoginWeb_input__kVbvz"};